var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-row',{staticStyle:{"padding":"0px"}},[_c('v-col',{staticClass:"slideExpandUp",attrs:{"cols":"12"}},[_c('Chat')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }